import {Route, Routes} from 'react-router-dom'
import CentralPageWrapper from '../khipu/features/central/pages/CentralPageWrapper'

const CentralRoutes = () => {
  return (
    <Routes>
      <Route index element={<CentralPageWrapper />} />
    </Routes>
  )
}

export {CentralRoutes}
